// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --section-padding-block: 32px;

    @media (min-width: 1025px) {
        --section-padding-block: 104px;
    }
}

#root {
    display: flex;
    flex-direction: column;
    flex: 1;
}

select {
    height: auto;
    padding: 0;
    border: unset;
    background-color: transparent !important;
}

select::before {
    border: 0;
}

.section {
    margin-top: var(--size-huge);
    padding-inline: var(--size-standard);
}

.home-page .section {
    margin-top: var(--section-padding-block);
}

.container {
    max-width: var(--content-width);
    margin-inline: auto;
}

.mobile-display {
    display: flex;
}

@media (min-width: 1025px) {
    .mobile-display {
        display: none;
    }
}

.desktop-display {
    display: none;
}

@media (min-width: 1025px) {
    .desktop-display {
        display: flex;
    }
}

.form {
    display: flex;
    flex-direction: column;
    gap: var(--size-standard);
}

.font-bold {
    font-family: var(--font-bold), sans-serif;
}

.font-gray {
    color: var(--gray-color);
}

.font-alert {
    color: var(--alert-text-color);
}

.font-warning {
    color: var(--warning-color)
}

.font-alert {
    color: var(--alert-text-color);
}

.font-green {
    color: var(--green-text-color);
}

.font-light-green {
    color: var(--bright-green);
}

.link {
    color: var(--brand-color)
}

.mt-standard {
    margin-top: var(--size-standard);
}

.mt-mini {
    margin-top: var(--size-mini);
}

.text-align-center {
    text-align: center;
}

.modal-result-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--size-standard);

    @media (min-width: 1025px) {
        gap: var(--size-big);
    }
}

.modal-result-title {
    font-family: 'Golos Bold', sans-serif;
    font-size: 18px;
    line-height: 20px;

    @media (min-width: 1025px) {
        font-size: 20px;
        line-height: 24px;
    }
}

.modal-result-button {
    @media (min-width: 1025px) {
        min-width: var(--column-fixed-size);
    }
}

/* MUI select options modal */
.MuiPopover-root .MuiPaper-root {
    border-radius: var(--size-medium);
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;;IAE7B;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;AACX;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,4BAA4B;IAC5B,oCAAoC;AACxC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI;AACJ;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;;IAEzB;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,iBAAiB;;IAEjB;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,mCAAmC;IACvC;AACJ;;AAEA,6BAA6B;AAC7B;IACI,iCAAiC;AACrC","sourcesContent":[":root {\n    --section-padding-block: 32px;\n\n    @media (min-width: 1025px) {\n        --section-padding-block: 104px;\n    }\n}\n\n#root {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n}\n\nselect {\n    height: auto;\n    padding: 0;\n    border: unset;\n    background-color: transparent !important;\n}\n\nselect::before {\n    border: 0;\n}\n\n.section {\n    margin-top: var(--size-huge);\n    padding-inline: var(--size-standard);\n}\n\n.home-page .section {\n    margin-top: var(--section-padding-block);\n}\n\n.container {\n    max-width: var(--content-width);\n    margin-inline: auto;\n}\n\n.mobile-display {\n    display: flex;\n}\n\n@media (min-width: 1025px) {\n    .mobile-display {\n        display: none;\n    }\n}\n\n.desktop-display {\n    display: none;\n}\n\n@media (min-width: 1025px) {\n    .desktop-display {\n        display: flex;\n    }\n}\n\n.form {\n    display: flex;\n    flex-direction: column;\n    gap: var(--size-standard);\n}\n\n.font-bold {\n    font-family: var(--font-bold), sans-serif;\n}\n\n.font-gray {\n    color: var(--gray-color);\n}\n\n.font-alert {\n    color: var(--alert-text-color);\n}\n\n.font-warning {\n    color: var(--warning-color)\n}\n\n.font-alert {\n    color: var(--alert-text-color);\n}\n\n.font-green {\n    color: var(--green-text-color);\n}\n\n.font-light-green {\n    color: var(--bright-green);\n}\n\n.link {\n    color: var(--brand-color)\n}\n\n.mt-standard {\n    margin-top: var(--size-standard);\n}\n\n.mt-mini {\n    margin-top: var(--size-mini);\n}\n\n.text-align-center {\n    text-align: center;\n}\n\n.modal-result-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: var(--size-standard);\n\n    @media (min-width: 1025px) {\n        gap: var(--size-big);\n    }\n}\n\n.modal-result-title {\n    font-family: 'Golos Bold', sans-serif;\n    font-size: 18px;\n    line-height: 20px;\n\n    @media (min-width: 1025px) {\n        font-size: 20px;\n        line-height: 24px;\n    }\n}\n\n.modal-result-button {\n    @media (min-width: 1025px) {\n        min-width: var(--column-fixed-size);\n    }\n}\n\n/* MUI select options modal */\n.MuiPopover-root .MuiPaper-root {\n    border-radius: var(--size-medium);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
